// tabbedSectionService.ts
import { api } from './api';

// TabbedSection API
export const getTabbedSections = () => api.get('/admin/tabbed-sections');
export const getTabbedSectionDetails = (id: number) => api.get(`/admin/tabbed-section/${id}`);
export const createTabbedSection = (data: any) => api.post('/admin/tabbed-section', data);
export const updateTabbedSection = (id: number, data: any) => api.patch(`/admin/tabbed-section/${id}`, data);
export const deleteTabbedSection = (id: number) => api.delete(`/admin/tabbed-section/${id}`);

// TabItem API
export const getTabItems = (sectionId: number) => api.get(`/admin/tabbed-section/${sectionId}/items`);
export const getTabItemDetails = (id: number) => api.get(`/admin/tab-item/${id}`);
export const createTabItem = (sectionId: number, data: any) => api.post(`/admin/tabbed-section/${sectionId}/item`, data);
export const updateTabItem = (id: number, data: any) => api.patch(`/admin/tab-item/${id}`, data);
export const deleteTabItem = (id: number) => api.delete(`/admin/tab-item/${id}`);

// Image upload for TabItem
export const uploadNewTabItemImage = (file: File, meta?: string) => {
    const formData = new FormData();
    formData.append('image', file);
    if (meta) formData.append('meta', meta);
    return api.post('/admin/tab-item/upload-image', formData);
};
export const uploadTabItemImage = (id: number, file: File, meta?: string) => {
    const formData = new FormData();
    formData.append('image', file);
    if (meta) formData.append('meta', meta);
    return api.post(`/admin/tab-item/${id}/upload-image`, formData);
};
